import React from 'react';
import PropTypes from 'prop-types';
import withConfig from 'HOCs/withConfig/withConfig';
import { FormattedMessage as Translation } from 'react-intl';
import css from './AdOverview.desktop.scss';
import { adpvAttributes } from 'Constants/items';
import { formatDate } from 'Helpers/dates';
import { X, WEBP_SVG_TYPE, XX } from 'Constants/images';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { getNeighbourhoodAndCity } from 'Helpers/locations';

export class AdOverview extends React.PureComponent {
    static propTypes = {
        item: PropTypes.object.isRequired,
        config: PropTypes.shape({
            get: PropTypes.func.isRequired
        }).isRequired,
        showInspectionTag: PropTypes.bool
    }

    carExtendedInspectedTagUri = this.props.config.get('adpvAuto', 'carExtendedInspectedTagUri')
    showNumDateFormat = this.props.config.get('adpvAuto', 'showNumDtFormat');

    renderAdditionalInfo = info => {
        let itemValue = info.value || '';
        const itemName = info.name || '';

        if (info.key === adpvAttributes.LOCATION) {
            const { city, neighbourhood } = getNeighbourhoodAndCity(this.props.item);

            itemValue = `${neighbourhood}${neighbourhood && city ? ', ' : ''}${city}`;
        }
        if (info.key === adpvAttributes.INSPECTION_DATE) {
            const date = new Date(info.value);

            itemValue = this.showNumDateFormat ? formatDate(date, 'MM/DD/YYYY') : formatDate(date, 'DD-MON-YY');
        }

        return (
            <div key={ info.key } className={ css.flexItem }>
                <div className={ css.itemIcon }>
                    <ImageWrapper
                        fileName={ info.imageURI }
                        fileSize={ X }
                        className={ css.img }
                        alt={ info.value }
                        types={ WEBP_SVG_TYPE } />
                </div>
                <div className={ css.blockContent }>
                    <div className={ css.itemName }>{itemName}</div>
                    <div className={ css.itemValue }>{itemValue}</div>
                </div>
            </div>
        );
    }
    render() {
        const { item, showInspectionTag } = this.props;
        const itemAdditionalParameters = item && item.inspectionDetails && item.inspectionDetails.additionalInfo
            && item.inspectionDetails.additionalInfo.parameters || [];

        return (<>
            <h3 data-aut-id="adOverview" className={ css.title }>
                { <Translation id="overview" /> }
            </h3>
            <div className={ css.separator } />
            { itemAdditionalParameters.length > 0
                ? (<div className={ css.additionalInfo }>
                    <div className={ css.flexContainer }>
                        {itemAdditionalParameters.map(this.renderAdditionalInfo)}
                    </div>
                </div>) : null
            }
            {showInspectionTag// for IND and ID only
            && <div className={ css.inspectedTag }>
                <ImageWrapper
                    fileName={ this.carExtendedInspectedTagUri }
                    fileSize={ XX }
                    types={ WEBP_SVG_TYPE }
                    alt="inspected car"
                />
            </div>
            }
        </>);
    }
}

export default withConfig(AdOverview);
